import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Tooltip from 'material-ui/Tooltip';

import { OHM_DECIMALS, PSIN_DECIMALS } from '../../../../../constants/globals';

export function ResultList({
  classes,
  characteristicImpedance,
  differentialImpedance,
  propagationalDelay
}){
  return (
    <List>
      <ListItem>
        <Avatar className={classes.resultAvatar}>
          <Tooltip title="Characteristic Impedance">
            <span>
              Z
              <sub>0</sub>
            </span>
          </Tooltip>
        </Avatar>
        <ListItemText>
          {characteristicImpedance.toFixed(OHM_DECIMALS)}
          {' '}
          Ω
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.resultAvatar}>
          <Tooltip title="Differential Impedance">
            <span>
              Z
              <sub>diff</sub>
            </span>
          </Tooltip>
        </Avatar>
        <ListItemText>
          {differentialImpedance.toFixed(OHM_DECIMALS)}
          {' '}
          Ω
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.resultAvatar}>
          <Tooltip title="Propagational Delay">
            <span>
              T 
              <sub>d</sub>
            </span>
          </Tooltip>
        </Avatar>
        <ListItemText>
          {propagationalDelay.toFixed(PSIN_DECIMALS)}
          {' '}
          ps/in
        </ListItemText>
      </ListItem>
    </List>
  );
}

ResultList.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  characteristicImpedance: PropTypes.number,
  differentialImpedance: PropTypes.number,
  propagationalDelay: PropTypes.number,
}

ResultList.defaultProps = {
  characteristicImpedance: 0,
  differentialImpedance: 0,
  propagationalDelay: 0
}

export default ResultList;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelModal/ResultList.jsx